<template>
  <div class="mainbody">
    <div v-cloak>
      <div class="location">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item> 管理中心 </el-breadcrumb-item>
          <el-breadcrumb-item>系统功能</el-breadcrumb-item>
          <el-breadcrumb-item>编辑海颐</el-breadcrumb-item>
        </el-breadcrumb>
      </div>

      <div class="content-box">
        <el-tabs v-model="activeName" type="card">
          <el-tab-pane label="基本信息" name="info">
            <div class="tab-content">
              <el-form
                ref="editForm"
                :model="model"
                :rules="rules"
                :label-position="labelPosition"
                label-width="120px"
              >
                <el-form-item label="设备公司" label-width="120px">
                  <cn-select-search
                    style="text-align: left"
                    ref="child"
                    v-model="model.companyId"
                    :v_disabled="disabled"
                    :data="companyList"
                    @val="setCompanyId"
                    placeholder="请筛选客户..."
                  >
                  </cn-select-search>
                </el-form-item>
                <el-form-item label="请选择设备" label-width="120px">
                  <el-select
                    v-model="model.deviceIds"
                    placeholder="请选择设备..."
                    class="sb_select"
                    multiple
                  >
                    <el-option
                      v-for="item in cabinetList"
                      :key="item.id"
                      :label="`${item.cabinetCode}  /  ${item.cabinetName}`"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item
                  label="公司名称"
                  label-width="120px"
                  prop="elecCustName"
                >
                  <el-input
                    v-model="model.elecCustName"
                    style="width: 240px"
                  ></el-input>
                </el-form-item>

                <el-form-item label="供电单位编码" label-width="120px">
                  <el-select v-model="model.supplyOrgCode" placeholder="请选择">
                    <el-option
                      v-for="item in code"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>

                <el-form-item
                  label="电压等级"
                  label-width="120px"
                  prop="voltCode"
                >
                  <el-input
                    v-model="model.voltCode"
                    style="width: 240px"
                  ></el-input>
                </el-form-item>

                <el-form-item
                  label="运行容量 KW"
                  label-width="120px"
                  prop="runCap"
                >
                  <el-input
                    v-model="model.runCap"
                    style="width: 240px"
                  ></el-input>
                </el-form-item>

                <el-form-item
                  label="最大上调容量"
                  label-width="120px"
                  prop="maxUpregCap"
                >
                  <el-input
                    v-model="model.maxUpregCap"
                    style="width: 240px"
                  ></el-input>
                </el-form-item>

                <el-form-item
                  label="最大下调容量"
                  label-width="120px"
                  prop="maxDownregCap"
                >
                  <el-input
                    v-model="model.maxDownregCap"
                    style="width: 240px"
                  ></el-input>
                </el-form-item>
              </el-form>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>

      <div class="footer-box">
        <div class="footer-btn">
          <el-button type="primary" @click="submitForm">确认保存</el-button>
          <el-button plain @click="resetForm">取消返回</el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import "../../js/tree.component.js";
import { AxiosAjax, getCompanyData } from "../../js/axios.config";
import "../../js/select.component.js";
export default {
  data() {
    return {
      disabled: false,
      activeName: "info", //当前选项卡
      labelPosition: "right", //表单对齐方式
      navListData: [],
      channelListData: [],
      companyList: [],
      cabinetList: [],
      model: {
        companyId: "",
        elecCustName: "",
        supplyOrgCode: "",
        voltCode: "",
        runCap: "",
        maxUpregCap: "",
        maxDownregCap: "",
        deviceIds: "",
      },
      code: [
        { id: "02", name: "交流220V" },
        { id: "03", name: "交流380V" },
        { id: "04", name: "交流660V" },
        { id: "05", name: "交流1000V" },
      ],
      rules: {
        companyId: [
          { required: true, message: "请选择所属客户", trigger: "change" },
        ],
        deviceIds: [
          { required: true, message: "请选择设备", trigger: "change" },
        ],
        supplyOrgCode: [
          { required: true, message: "请选择供电单位编码", trigger: "change" },
        ],
        voltCode: [
          { required: true, message: "请输入电压等级", trigger: "blur" },
        ],
        runCap: [
          { required: true, message: "请输入运行容量", trigger: "blur" },
        ],
        maxUpregCap: [
          { required: true, message: "请输入最大上调容量", trigger: "blur" },
        ],
        maxDownregCap: [
          { required: true, message: "请输入最大下调容量", trigger: "blur" },
        ],
        elecCustName: [
          { required: true, message: "请输入公司名称", trigger: "blur" },
        ],
      },
    };
  },
  mounted() {},
  methods: {
    //初始化数据
    initData: function () {
      this.companyList = getCompanyData();
    },
    submitForm: function () {
      let _this = this; //当前页面
      console.log(_this.model);
      if (_this.$route.query.id == 1) {
        _this.model.deviceIds = _this.model.deviceIds.join(",");
        AxiosAjax({
          method: "post",
          url: "/cabinet/haiyi/user/create",
          data: _this.model,
          loading: true,
          success: function (res) {
            if (res.data.code == "000000") {
              setTimeout(() => {
                window.history.back(-1);
              }, 100);
              _this.$message({
                message: "新增成功",
                type: "success",
              });
            }
          },
        });
      }
    },
    resetForm() {
      window.history.back(-1);
    },
    getCabinetList: function (companyId) {
      let _this = this; //当前
      _this.cabinetList = [];
      //加载设备列表
      AxiosAjax({
        url: "/cabinet/cabinet/page?index=1&size=9000&companyId=" + companyId,
        loading: true,
        success: function (res) {
          _this.cabinetList = res.data.data.content;
        },
      });
    },
    setCompanyId(obj) {
      this.model.companyId = obj.toString();
      this.getCabinetList(this.model.companyId);
    },
  },
  created: function () {
    //初始化数据
    this.initData();
  },
};
</script>
<style scoped>
/deep/ .el-form-item__error {
  position: static;
}
</style>


// WEBPACK FOOTER //
// src/components/HaiYi/HaiYiEdit.vue